import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlusIcon, SearchIcon } from "../../utils/icons";
import SimpleLoading from "../LoadingComponent/SimpleLoading";
import UserInUserList from "./UserInUserList";
import MyDropDown2 from "../Interactions/MyDropDown";
import { 
  getUserListThunk, 
  getConnectedUserListThunk,
  getUserMessageByIdthunk, 
  setConnectedUserListReducer, 
  setMessageDetailsReducer, 
  setMsgLoading, 
  setSelectedUserOrChannel, 
  updateUserPrivateMsgStatusThunk, 
  getUserSmePartnerAdminListThunk
} from '../../slices/userSlice';

const dropDownFilterData = ["All", "Talent", "SME", "Partner", "Admin"];
let i = 0;

const UserLists = ({ handleSelectionChange=()=>{} }) => {
  const dispatch = useDispatch();
  const { userList, smeList, partnerList, adminList, userType, } = useSelector((state) => state.user) || {};
  const [allData, setAllData] = useState({ Talent: userList, SME: smeList, Partner: partnerList, Admin: adminList });
  const [allDataAfterFilter, setAllDataAfterFilter] = useState({ Talent: userList, SME: smeList, Partner: partnerList, Admin: adminList });
  const [filteredAll, setFilteredAll] = useState({ Talent: userList, SME: smeList, Partner: partnerList, Admin: adminList });
  const [userLoading, setUserLoading] = useState(false);
  const [selectedListFilter, setSelectedListFilter] = useState('All');
  const [allNewMsgUsersPKList, setAllNewMsgUsersPKList] = useState([]);
  const newMsgDetailObj = useSelector((state) => state.user.newMsgDetailObj) || {};
  const newMsgDetailObjRef = useRef(newMsgDetailObj);


  const addUserToLists = (user, type, newData, distributedData, allNewMsgUsersPk) => {
    console.log(newMsgDetailObjRef.current, "== newMsgDetailObj:addUserToList, ", i++,  " == i, ", selectedListFilter);
    
    if (user) {
      if (newMsgDetailObjRef.current[user.PK] || allNewMsgUsersPk.includes(user.PK)) {
        distributedData[type].push(user);
        if (!allNewMsgUsersPk.includes(user.PK)) {
          allNewMsgUsersPk.push(user.PK);
        }
      } else {
        newData[type].push(user);
      }
    }
  };


  const newMsgUserFilteration = ({ UserList = [], SMEList = [], PartnerList = [], AdminList = [] }) => {
    const max = Math.max(UserList.length, SMEList.length, PartnerList.length, AdminList.length);
    
    const newData = { Talent: [], SME: [], Partner: [], Admin: [] };
    const distributedData = { Talent: [], SME: [], Partner: [], Admin: [] };
    const allNewMsgUsersPk = [...allNewMsgUsersPKList];
  
    for (let i = 0; i < max; i++) {
      addUserToLists(UserList[i], "Talent", newData, distributedData, allNewMsgUsersPk);
      addUserToLists(SMEList[i], "SME", newData, distributedData, allNewMsgUsersPk);
      addUserToLists(PartnerList[i], "Partner", newData, distributedData, allNewMsgUsersPk);
      addUserToLists(AdminList[i], "Admin", newData, distributedData, allNewMsgUsersPk);
    }
  
    const dataToBeSet = { ...newData };
  // debugger
    if (selectedListFilter === "All") {
      dataToBeSet["Talent"] = [
        ...distributedData.Talent,
        ...distributedData.SME,
        ...distributedData.Partner,
        ...distributedData.Admin,
        ...dataToBeSet.Talent
      ];
    } else if (selectedListFilter in distributedData) {
      dataToBeSet[selectedListFilter] = [
        ...distributedData[selectedListFilter],
        ...dataToBeSet[selectedListFilter]
      ];
    }
  
    setAllNewMsgUsersPKList(allNewMsgUsersPk);
    setFilteredAll({ ...dataToBeSet, Talent: dataToBeSet.Talent.slice(0, 15), });
    setAllDataAfterFilter(dataToBeSet);
    setSelectedListFilter(selectedListFilter);
    // setAllData({ Talent: UserList, SME: SMEList, Partner: PartnerList, Admin: AdminList });
  };


  useEffect(() => {
    // if (userList?.length === 0) {
      setUserLoading(true);
      // if (localStorage.getItem("type") === "Admin") {
      dispatch(getUserSmePartnerAdminListThunk({ userType }))
        .unwrap()
        .then((res) => {
          console.log(res, "===getUserListThunk==");
          newMsgUserFilteration({ ...res.data });
          setAllData({ Talent: res.data.UserList, SME: res.data.SMEList, Partner: res.data.PartnerList, Admin: res.data.AdminList });
          setUserLoading(false);
        })
        .catch((e) => {
          setUserLoading(false);
        });

      dispatch(getConnectedUserListThunk({ type: userType }))
        .unwrap()
        .then((res) => {
          const connectedIds = res.map((data) => data.PK.S);
          dispatch(setConnectedUserListReducer(connectedIds));
          console.log(res, "res:setConnectedUsersetConnectedUser");
        })
        .catch((err) => {
          console.log(err, " =error:setConnectedUser");
        });
      // }
    // }
  }, []);


  useEffect(()=>{
    newMsgDetailObjRef.current = newMsgDetailObj;
    newMsgUserFilteration({ UserList: allData.Talent, SMEList: allData.SME, PartnerList: allData.Partner, AdminList: allData.Admin });
  }, [newMsgDetailObj]);




  const handleSearchUser = (e) => {
    const value = e.target.value?.toLocaleLowerCase();

    if (!value) return setFilteredAll({ ...allDataAfterFilter });
    const filteredUsersList = allDataAfterFilter.Talent?.filter((user) =>
      user?.Name?.toLocaleLowerCase()?.includes(value)
    );
    const filteredSmeList = allDataAfterFilter.SME?.filter((sme) =>
      sme?.Name?.toLocaleLowerCase()?.includes(value)
    );
    const filteredPartnerList = allDataAfterFilter.Partner?.filter((partner) =>
      partner?.Name?.toLocaleLowerCase()?.includes(value)
    );
    const filteredAdminList = allDataAfterFilter.Admin?.filter((admin) =>
      admin?.Name?.toLocaleLowerCase()?.includes(value)
    );
    setFilteredAll({ Talent: filteredUsersList, Admin: filteredAdminList, SME: filteredSmeList, Partner: filteredPartnerList });
  };

  const getType = (PK) => {
    if(PK.includes("User#")) return null;
    if(PK.includes("SME#")) return 'SME';
    if(PK.includes("Partner#")) return 'Partner';
    if(PK.includes("Admin#")) return 'Admin';
  }

  const changeUserTypeDropDown = (key) => {
    // debugger
    let newData = { Talent: [], SME: [], Partner: [], Admin: [] };
    if(key === "All"){
      newData = { ...allDataAfterFilter };
    }
    else {
      const specUserList = allData[key];
      const mylist = [];
      for (let i = 0; i < specUserList.length; i++) {
        const user = specUserList[i];
        if(newMsgDetailObj[user.PK]){
          mylist.unshift(user);
        }
        else {
          mylist.push(user);
        }
      }
      newData[key] = mylist;
    }
    setSelectedListFilter(key);
    setFilteredAll(newData);
  }

  console.log(allDataAfterFilter, "===selectedListFilterselectedListFilter");
  
  const getUserListByKey = (key) => {
    if(filteredAll[key]?.length > 0){
      return(
        <>
         {filteredAll[key]?.map(items => {
            const type = getType(items.PK)
            return (
              <UserInUserList
                key={items.PK}
                items={items}
                type={type}
                onClick={() => handleSelectionChange({ ...items, type: 'user', })}
              />
            );
         })}
       </>
      )
    }
    else if(key === selectedListFilter){
      return (<p className="text-gray-600 text-center">No {key} Available</p>)
    }
  }


  return (
    <div className="min-w-[230px] w-[25%] mr-1 rounded-3xl p-2 pb-3 shadow-chatBoxShadow overflow-hidden">
      <div className="flex items-center justify-between bg-pureWhite p-1 mb-2">
        <MyDropDown2 
          items={dropDownFilterData?.map(item => ({ key: item, label: item }))}
          selectedValue={selectedListFilter}
          onChange={changeUserTypeDropDown}
          size="middle"
          className="w-[40%]"
          borderRadius="8px"
        />
        <span className="cursor-pointer w-[50%] flex justify-end">
          <PlusIcon className="plus-icon" />
        </span>
      </div>
      <div className="flex items-center bg-pureWhite p-1 border-2 border-gray-300 rounded-lg mb-2">
        <input
          placeholder="Search"
          className="outline-none w-[90%] pl-1 pr-3"
          onChange={handleSearchUser}
        />
        <span className="w-[10%] h-4">
          <SearchIcon />
        </span>
      </div>
      <div className="h-full overflow-y-auto pb-20">
        {userLoading ? (
          <div className="ml-6">
            <SimpleLoading />
          </div>
        ) : (
            <>
              {(selectedListFilter === 'All' || selectedListFilter === 'Talent') && getUserListByKey("Talent")}
              {(selectedListFilter === 'All' || selectedListFilter === 'SME') && getUserListByKey("SME")}
              {(selectedListFilter === 'All' || selectedListFilter === 'Partner') && getUserListByKey("Partner")}
              {(selectedListFilter === 'All' || selectedListFilter === 'Admin') && getUserListByKey("Admin")}
            </>
        )}
      </div>
    </div>
  );
};

export default UserLists;




































// import React, { useEffect, useState } from 'react'
// import { getConnectedUserListThunk, getUserListThunk, getUserSmePartnerAdminListThunk, setConnectedUserListReducer } from '../../slices/userSlice';
// import { useDispatch, useSelector } from 'react-redux';
// import { PlusIcon, SearchIcon } from '../../utils/icons';
// import SimpleLoading from '../LoadingComponent/SimpleLoading';
// import UserInUserList from './UserInUserList';
// import MyDropDown2 from '../Interactions/MyDropDown';

// const dropDownFilterData = ["All", "Talent", "SME", "Partner", "Admin"];

// const UserLists = ({ handleSelectionChange }) => {
//     const dispatch = useDispatch();
//     const { userList, smeList, partnerList, adminList, userType, } = useSelector((state) => state.user) || {};
//     const [allData, setAllData] = useState({ Talent: userList, SME: smeList, Partner: partnerList, Admin: adminList });
//     const [filteredAll, setFilteredAll] = useState(userList);
//     const [userLoading, setUserLoading] = useState(false);
//     const [selectedListFilter, setSelectedListFilter] = useState('All');

//     useEffect(()=>{
//         // if(userList?.length === 0){
//             setUserLoading(true);
//             dispatch(getUserSmePartnerAdminListThunk())
//             .unwrap()
//             .then((res) => {
//                 console.log(res, "===getUserListThunk==:new:2");
//                 const data = { Talent: res.data.UserList, SME: res.data.SMEList, Partner: res.data.PartnerList, Admin: res.data.AdminList }
//                 setFilteredAll({ ...data, Talent: res.data.UserList.slice(0, 10) });
//                 setAllData(data);
//                 setUserLoading(false);
//             })
//             .catch((e) => {
//                 setUserLoading(false);
//             });
    
//             dispatch(getConnectedUserListThunk())
//             .unwrap()
//             .then((res) => {
//                 const connectedIds = res.map((data) => data.PK.S);
//                 dispatch(setConnectedUserListReducer(connectedIds));
//                 console.log(res, "res:setConnectedUsersetConnectedUser");
//             })
//             .catch((err) => {
//                 console.log(err, " =error:setConnectedUser");
//             });
//         // }
//     }, []);

//     const handleSearchUser = (e) => {
//       const value = e.target.value?.toLocaleLowerCase();
  
//       // console.log(value, " === searchValue, ", userList, "===userListtt");
      
  
//       if (!value) return setFilteredAll({ ...allData, Talent: allData.Talent.slice(0, 10) });
//       const filteredUsersList = userList?.filter((user) =>
//         user?.Name?.toLocaleLowerCase()?.includes(value)
//       );
//       const filteredSmeList = smeList?.filter((sme) =>
//         sme?.Name?.toLocaleLowerCase()?.includes(value)
//       );
//       const filteredPartnerList = partnerList?.filter((partner) =>
//         partner?.Name?.toLocaleLowerCase()?.includes(value)
//       );
//       const filteredAdminList = adminList?.filter((admin) =>
//         admin?.Name?.toLocaleLowerCase()?.includes(value)
//       );
//       setFilteredAll({ Talent: filteredUsersList, Admin: filteredAdminList, SME: filteredSmeList, Partner: filteredPartnerList });
//     };
  
//     const getType = (PK) => {
//       if(PK.includes("User#")) return null;
//       if(PK.includes("SME#")) return 'SME';
//       if(PK.includes("Partner#")) return 'Partner';
//       if(PK.includes("Admin#")) return 'Admin';
//     }
  
//     const changeUserTypeDropDown = (key) => {
//       setSelectedListFilter(key);
//       let newData = { Talent: [], SME: [], Partner: [], Admin: [] };
//       if(key === "All"){
//         newData = { ...allData };
//       }
//       else {
//         newData[key] = allData[key];
//       }
//       setFilteredAll(newData);
//     }
    

//     return (
//       <div className="min-w-[230px] w-[25%] mr-1 rounded-3xl p-2 pb-3 shadow-chatBoxShadow overflow-hidden">
//       <div className="flex items-center justify-between bg-pureWhite p-1 mb-2">
//         {/* <p>User List</p> */}
//         <MyDropDown2
//           // items={[{ key: 'All', label: 'All' }, { key: 'User', label: 'User' }, { key: 'SME', label: 'SME' }, { key: 'Admin', label: 'Admin' },]} 
//           // items={[{ key: "All", label: "All" }, ...Object.keys(filteredAll)?.map(item => ({ key: item, label: item })),]}
//           items={dropDownFilterData?.map(item => ({ key: item, label: item }))}
//           selectedValue={selectedListFilter}
//           onChange={changeUserTypeDropDown}
//           size="middle"
//           className="w-[40%]"
//           borderRadius="8px"
//         />
//         <span className="cursor-pointer w-[50%] flex justify-end">
//           <PlusIcon className="plus-icon" />
//         </span>
//       </div>
//       <div className="flex items-center bg-pureWhite p-1 border-2 border-gray-300 rounded-lg mb-2">
//         <input
//           placeholder="Search"
//           className="outline-none w-[90%] pl-1 pr-3"
//           onChange={handleSearchUser}
//         />
//         <span className="w-[10%] h-4">
//           <SearchIcon />
//         </span>
//       </div>
//       <div className="h-full overflow-y-auto pb-20">
//         {userLoading ? (
//           <div className="ml-6">
//             <SimpleLoading />
//           </div>
//         ) : (
//           Object.keys(filteredAll)?.map((key, i) => {
//             if(filteredAll[key]?.length > 0){
//               return(
//                 <>
//                  {filteredAll[key]?.map(items => {
//                     const type = getType(items.PK)
//                     return (
//                       <UserInUserList
//                         key={i}
//                         items={items}
//                         type={type}
//                         onClick={() => handleSelectionChange({ ...items, type: 'user', })}
//                       />
//                     );
//                  })}
//                </>
//               )
//             }
//             else if(key === selectedListFilter){
//               return (<p className="text-gray-600 text-center">No {key} Available</p>)
//             }
//           })
//         )}
//       </div>
//     </div>
//     );
// }

// export default UserLists
